import { DOCUMENT_UPLOAD_STEP_PATHS } from '@/constants';
import Documents from '@/containers/Documents';
import { DocumentUploadSuccess } from '@/containers/DocumentUploadSuccess';
import { not } from '@/flow/common';
import { shouldCollectDocuments } from '@/selectors/documentUpload';

export const defaultDocumentUploadFlow = options => {
  return {
    stepNotFoundPath: DOCUMENT_UPLOAD_STEP_PATHS.DOCUMENTS,
    globalPrerequisites: [],
    selectors: {
      shouldCollectDocuments,
    },
    neededCaps: {},
    steps: [
      {
        id: 'documents',
        path: DOCUMENT_UPLOAD_STEP_PATHS.DOCUMENTS,
        Container: Documents,
        skip: not('shouldCollectDocuments'),
        back: false,
        next: DOCUMENT_UPLOAD_STEP_PATHS.SUCCESS_PATH,
      },
      {
        id: 'success',
        path: DOCUMENT_UPLOAD_STEP_PATHS.SUCCESS_PATH,
        Container: DocumentUploadSuccess,
        prerequisite: not('shouldCollectDocuments'),
        back: DOCUMENT_UPLOAD_STEP_PATHS.DOCUMENTS,
        next: false,
      },
    ],
  };
};
